import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { ICommonServiceProps } from "@api/types/globalService.types";
import { CACHE_KEYS } from "@api/constants/cacheKeys";
import URLS from "@api/constants/urls";
import { handleGlobalGetRequestQuery } from "@api/functions/getRequests";
import useGlobalDebounceHandler from "./useGlobalDebounceHandler";

export const useGetAllCancellationReasonsService = ({
  page = "1",
  per_page = "15",
  enableQuery = true,
  cacheKeys = [],
  filters = {},
}: ICommonServiceProps) => {
  const [cancellationReasonsSearchQuery, setCancellationReasonsSearchQuery] =
    useState("");
  const { debouncedQuery } = useGlobalDebounceHandler(
    cancellationReasonsSearchQuery
  );

  const allCancellationReasonsService = useQuery({
    queryKey: [
      ...CACHE_KEYS.CANCELLATION_REASONS,
      page,
      per_page,
      debouncedQuery,
      JSON.stringify(filters),
      ...cacheKeys,
    ],
    queryFn: () => {
      return handleGlobalGetRequestQuery({
        url: URLS?.CANCELLATION_REASONS,
        searchParams: {
          "filter[text]": debouncedQuery,
          page,
          per_page,
          ...filters,
        },
      });
    },
    enabled: enableQuery,
  });
  return {
    service: { allCancellationReasonsService },
    states: {
      cancellationReasonsSearchQuery,
      setCancellationReasonsSearchQuery,
    },
  };
};
